import './App.css';

export default function Main() {
    return null;
}
